import { FC, PropsWithChildren } from 'react';

export const FilterFormWrapper: FC<PropsWithChildren<HTMLFormElement>> = ({
  children,
  onSubmit,
}) => {
  return (
    <form
      id="notificationFilterForm"
      data-testid="filterForm"
      onSubmit={onSubmit}
    >
      {children}
    </form>
  );
};
